mutation createProject($input: CreateProjectInput!) {
	createProject(input: $input) {
		id
		sourceImageKey
	}
}